import React from 'react';
import { Grid, Stack } from '../library';
import { Typography } from '@mui/material';
import { getValueFormatted } from '../helpers';

const getValue = (value, property) => {
    const p = property.split('.');

    if (p.length === 1) return value[p];

    return getValue(value[p[0]], p.slice(1).join('.'));
};

const MultiValue = props => {
    const { values, property, children, color, type } = props;

    return (
        <Grid
            container
            spacing={1}
            alignItems='center'
            justifyContent={'flex-start'}
        >
            {values.map((v, index) => (
                <Grid item>
                    <Stack
                        direction='row'
                        alignItems='center'
                        justifyContent={'center'}
                        spacing={0.2}
                    >
                        {children && children}
                        <Typography variant={'caption'} color={color && color}>
                            {getValueFormatted(type, getValue(v, property))}
                        </Typography>
                    </Stack>
                </Grid>
            ))}
        </Grid>
    );
};

export default MultiValue;
